import React, { useMemo, useState } from 'react';
import '../styles/Portal.css';

const Portal = ({ title, description, url, mobileTitle }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const runes = useMemo(() => ['ᚠ', 'ᚢ', 'ᚦ', 'ᚨ', 'ᚱ', 'ᚲ', 'ᚷ', 'ᚹ'], []);
  const runeRadius = 168;

  return (
    <div
      className={`portal-wrapper ${isHovered ? 'hovered' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <div className="portal-circle">
        <div className="portal-content">
          <h3 className="portal-title desktop-only">{title}</h3>
          <p className="portal-description desktop-only">{description}</p>
          <span className="portal-mobile-title mobile-only">{mobileTitle}</span>
        </div>

        <div className="portal-inner-glow"></div>
      </div>

      <div className="runes-circle" aria-hidden="true">
        {runes.map((rune, index) => {
          const angle = index * (360 / runes.length);
          return (
            <div
              key={index}
              className="rune"
              style={{
                transform: `translate(-50%, -50%) rotate(${angle}deg) translateX(${runeRadius}px) rotate(-${angle}deg)`
              }}
            >
              <span>{rune}</span>
            </div>
          );
        })}
      </div>

      <div className="portal-light-effect"></div>
    </div>
  );
};

export default Portal;
